import { useState, useEffect } from 'react';

/**
 * Returns true when viewport width is at or below maxWidth (default 767px).
 * SSR-safe: defaults to false so desktop layout is assumed until hydration.
 * @param {number} [maxWidth=767] - Max viewport width in px for "mobile" (below md breakpoint).
 * @returns {boolean}
 */
export function useIsMobile(maxWidth = 767) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, [maxWidth]);

  return isMobile;
}
